import { render, staticRenderFns } from "./VDownloadMobile.vue?vue&type=template&id=4453da20"
import script from "./VDownloadMobile.vue?vue&type=script&lang=js"
export * from "./VDownloadMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports